import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";

export class AccountsDisplayListCtrl implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;
  disabledIds: any;
  noPickUp?: boolean;
  noDropOff?: boolean;
  onChangeFilterNoPickUp: Function;
  onChangeFilterNoDropOff: Function;
  onChange: Function;

  private accountsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, private $log) {

  }
  $onInit() {
    this.accountsRef = this.$accounts();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.accountsRef.$asyncValues(ids)
        .then((accounts) => {
          const displayItems = [];
          _.forEach(accounts, (a) => {
            displayItems.push({id: a.id, value: a.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('accountsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      disabledIds: '<?',
      noPickUp: '<?',
      noDropOff: '<?',
      onChangeFilterNoPickUp: '&',
      onChangeFilterNoDropOff: '&',
      onChange: '&'
    },
    template: require('./accounts-display-list.html').default,
    controller: AccountsDisplayListCtrl
  });
